import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";

@Component({
  selector: 'app-biology-lab',
  templateUrl: './biology-lab.component.html',
  styleUrls: ['./biology-lab.component.scss']
})
export class BiologyLabComponent implements OnInit {    
  selectedLanguage = "";
  biology_lab: any[] = [];

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Chemistry API Response");

      if (response?.data) {
        // Filter for Library category
        this.biology_lab  = response.data.filter(
          (x: any) => x.ContentCategoryName === "Biology Lab"
        );
        console.log(this.biology_lab , "Filtered chemistry Data");
      }
    });
  }
}
